import {client} from '../helpers/api';

export async function getTeacher(tId) {
  const teacherIdQs = `teacher_id=${tId}`;

  const response = await client.get(`/api/teacher_schedules?${teacherIdQs}`);

  if (response.data?.status) {
    return (
      response.data?.data.map(
        ({
          teacher_id: id,
          teacher_name: name,
          teacher_image: image,
          description,
          schedule_id: scheduleId,
          _subject_id: subjectId,
          _grade_id: gradeId,
          _teacher_id: teacherId,
          week_day: weekDay,
          start_time: startTime,
          end_time: endTime,
          zoom_class_link: classLink,
        }) => ({
          id,
          name,
          image,
          description,
          scheduleId,
          subjectId,
          gradeId,
          teacherId,
          weekDay,
          startTime,
          endTime,
          classLink,
        }),
      ) || []
    );
  }
  throw response;
}

// {
//   "teacher_id": "09a41150-3f30-47a3-a198-ad49d7fe610f",
//   "teacher_name": "Ahmad",
//   "teacher_image": "default_teacher.png",
//   "description": "Good teacher",
//   "date_created": "2021-01-10 22:36:11",
//   "date_modified": "2021-01-10 22:36:11",
//   "status": "active",
//   "is_deleted": 0,
//   "schedule_id": "2c576549-c9c3-46a9-a3b7-ed78f7d488fd",
//   "_subject_id": "830bde66-e7c6-4e53-9f96-6fb9ed8bb31c",
//   "_grade_id": "c6e482fb-e36b-4cc0-bd45-acaaf0f53723",
//   "_teacher_id": "09a41150-3f30-47a3-a198-ad49d7fe610f",
//   "week_day": "SUN",
//   "start_time": "10:00",
//   "end_time": "11:00",
//   "zoom_class_link": null
// }
